import React from 'react';
import selectors from '../hooks/selectors';
import SaveThemeDialog from './SaveThemeDialog';

const ThemeDialogs = ({ theme }) => {
  const { allowSave } = selectors.useThemeDialogs();
  return (
    <>
      {allowSave && (<SaveThemeDialog theme={theme} />)}
    </>
  );
};

export default ThemeDialogs;
